<div #modalWrapper>
  <div class="prequal-info" [ngClass]="{'showConfirmationmodal': showConfirmation, 'noVinContent': !isVinAvailable, 'noVinContentsuccess': !isVinAvailable && showConfirmation&& outcome && outcome.prequalAmt > 0,
    'noVinContentsuccessamt0': !isVinAvailable && showConfirmation && outcome && outcome.prequalAmt === 0
   }">
    <div class="pre-qual-close" (click)="cleanupAngularModal(showConfirmation)">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32Z"
          fill="var(--grayscale-100)" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M21.6298 19.8277C22.1276 20.3258 22.1276 21.1307 21.6298 21.6288C21.3814 21.8772 21.0554 22.0019 20.7291 22.0019C20.4031 22.0019 20.077 21.8772 19.8287 21.6288L16.0016 17.8014L12.1744 21.6288C11.9261 21.8772 11.6001 22.0019 11.2741 22.0019C10.9478 22.0019 10.6218 21.8772 10.3734 21.6288C9.87553 21.1307 9.87553 20.3258 10.3734 19.8277L14.2007 16.0006L10.3734 12.1735C9.87553 11.6754 9.87553 10.8705 10.3734 10.3724C10.8715 9.87455 11.6763 9.87455 12.1744 10.3724L16.0016 14.1998L19.8287 10.3724C20.3268 9.87455 21.1316 9.87455 21.6298 10.3724C22.1276 10.8706 22.1276 11.6754 21.6298 12.1735L17.8024 16.0006L21.6298 19.8277Z"
          fill="var(--grayscale-700)" />
      </svg>
    </div>
    <div *ngIf="!showConfirmation" class="pre-qual-data">

      <ngx-ui-loader [loaderId]="'creditApplicationPreQual'"
        [ngClass]="{'isBackButton': hasbackButton, 'noBackButton': !hasbackButton}"></ngx-ui-loader>
      <div *ngIf="apiDomain && storeDataWithDomain && storeDataWithDomain.Brands " class="store-info-t3">
        <div class="store-info-log">
          <span *ngFor="let store of storeDataWithDomain.Brands">
            <img src="{{store}}" onerror='this.style.display = "none"' />
          </span>
        </div>
        <div class="store-info-name">
          {{storeDataWithDomain.storeName}}
        </div>
      </div>
      <h1 class="col-12  p-0 prequal-title an-h-line-height text-secondary-dark"
        [ngClass]="{'legacy-credit-prequal-title':  isLegacyCreditApp, 'prequal-title-t3' : apiDomain}">{{ apiDomain ?
        "Get Pre-Qualified in Minutes" : SCData?.PreQualTitle}}</h1>
      <div class="prequal-subtitle-t3 an-p-line-height" *ngIf="apiDomain">
        There’s no impact to your credit score!
      </div>
      <div class="secure-text-box" [ngClass]="{'secure-text-box-t3' : apiDomain}">


        <svg *ngIf="!apiDomain" width="12" height="12" viewBox="0 0 12 12" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g id="Icon" clip-path="url(#clip0_225_674)">
            <g id="Lock">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M2.5 5.87921C2.15482 5.87921 1.875 6.15903 1.875 6.50421V10.0042C1.875 10.3494 2.15482 10.6292 2.5 10.6292H9.5C9.84518 10.6292 10.125 10.3494 10.125 10.0042V6.50421C10.125 6.15903 9.84518 5.87921 9.5 5.87921H2.5ZM1.125 6.50421C1.125 5.74482 1.74061 5.12921 2.5 5.12921H9.5C10.2594 5.12921 10.875 5.74482 10.875 6.50421V10.0042C10.875 10.7636 10.2594 11.3792 9.5 11.3792H2.5C1.74061 11.3792 1.125 10.7636 1.125 10.0042V6.50421Z"
                fill="var(--text-heading)" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M6 1.37921C5.43641 1.37921 4.89591 1.60309 4.4974 2.00161C4.09888 2.40012 3.875 2.94063 3.875 3.50421V5.50421C3.875 5.71132 3.70711 5.87921 3.5 5.87921C3.29289 5.87921 3.125 5.71132 3.125 5.50421V3.50421C3.125 2.74171 3.4279 2.01045 3.96707 1.47128C4.50624 0.932112 5.2375 0.629211 6 0.629211C6.7625 0.629211 7.49376 0.932112 8.03293 1.47128C8.5721 2.01045 8.875 2.74171 8.875 3.50421V5.50421C8.875 5.71132 8.70711 5.87921 8.5 5.87921C8.29289 5.87921 8.125 5.71132 8.125 5.50421V3.50421C8.125 2.94063 7.90112 2.40012 7.5026 2.00161C7.10409 1.60309 6.56359 1.37921 6 1.37921Z"
                fill="var(--text-heading)" />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_225_674">
              <rect width="12" height="12" fill="white" transform="translate(0 0.00421143)" />
            </clipPath>
          </defs>
        </svg>
        <svg *ngIf="apiDomain" xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18"
          fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M3.58961 8.82387C3.1023 8.82387 2.70726 9.21892 2.70726 9.70623V14.6474C2.70726 15.1347 3.1023 15.5298 3.58961 15.5298H13.472C13.9593 15.5298 14.3543 15.1347 14.3543 14.6474V9.70623C14.3543 9.21892 13.9593 8.82387 13.472 8.82387H3.58961ZM1.64844 9.70623C1.64844 8.63414 2.51753 7.76505 3.58961 7.76505H13.472C14.5441 7.76505 15.4131 8.63414 15.4131 9.70623V14.6474C15.4131 15.7195 14.5441 16.5886 13.472 16.5886H3.58961C2.51753 16.5886 1.64844 15.7195 1.64844 14.6474V9.70623Z"
            fill="var(--grayscale-800)" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M8.53079 2.47093C7.73514 2.47093 6.97208 2.787 6.40947 3.34961C5.84686 3.91222 5.53079 4.67528 5.53079 5.47093V8.29446C5.53079 8.58685 5.29376 8.82387 5.00138 8.82387C4.70899 8.82387 4.47197 8.58685 4.47197 8.29446V5.47093C4.47197 4.39447 4.89959 3.36209 5.66077 2.60091C6.42195 1.83973 7.45432 1.41211 8.53079 1.41211C9.60726 1.41211 10.6396 1.83973 11.4008 2.60091C12.162 3.36209 12.5896 4.39447 12.5896 5.47093V8.29446C12.5896 8.58685 12.3526 8.82387 12.0602 8.82387C11.7678 8.82387 11.5308 8.58685 11.5308 8.29446V5.47093C11.5308 4.67528 11.2147 3.91222 10.6521 3.34961C10.0895 2.787 9.32644 2.47093 8.53079 2.47093Z"
            fill="var(--grayscale-800)" />
        </svg>
        <span class="secure-text-msg" [ngClass]="{'secure-text-msg-t3' : apiDomain}">{{apiDomain ? "Secure Application"
          :
          "Information submitted securely."}}</span>
      </div>
      
      <form novalidate [formGroup]="preQualForm" class="col-12 scrollDiv prequalForm"
        [ngClass]="{'legacy-prequal-form':  isLegacyCreditApp, 'prequal-t3-form' : apiDomain}">
        <div class="row m-0 preQualFormRow">
          <div class="col-12 rail leftRail">
            <!-- Start if First Name-->
            <div class="row mx-0 form-row w-100 form-row-name">
              <div [class.disabled]="submitClicked || preQualForm.disabled"  class="col-6 col-md-6 col-lg-6 col-xl-6 position-relative floating-label-wrapper mw-230 mar-rig-8">
                <div class="floating-label-group " [class.floating-active]="getFloatingState('FirstName', firstname)" [class.focused]="focusState['FirstName']">
                  <input id="first_name" class="form-control w-100" formControlName="FirstName" maxlength="30"
                    [disabled]="preQualForm.disabled || preQualForm.invalid || submitClicked"
                    type="text" autocomplete="first_name" placeholder="ex: John"
                    (focus)="preQualForm.get('FirstName').markAsUntouched(); firstname.focus(); onFieldFocus('FirstName', true);"
                    (blur)="onFieldFocus('FirstName', false)" #firstname [ngClass]="{
                    'form-row-err':
                      !hasFocus(firstname) && (preQualForm.get('FirstName').touched ||
                        preQualForm.get('FirstName').dirty) &&
                      !preQualForm.get('FirstName').valid 
                  }" />
                  <label for="first_name">
                    {{ SCData?.FirstName }}
                  </label>
                </div>
                <!-- <div class="valid-checkmark-icon valid-icon" *ngIf="preQualForm.get('FirstName')?.valid"> </div>
                <div class="valid-checkmark-icon invalid-icon"
                  *ngIf="preQualForm.get('FirstName')?.invalid && preQualForm.get('FirstName')?.touched"> </div> -->
                <div class="invalid-feedback error-width-for-half-row d-flex"
                  (click)="preQualForm.get('FirstName').markAsUntouched(); firstname.focus()" *ngIf="
                !hasFocus(firstname) &&
                preQualForm.get('FirstName').touched &&
                !preQualForm.get('FirstName').valid
              ">
                  <span class="form-validator_error" role="alert">
                    <ng-container *ngIf="!!preQualForm.get('FirstName').errors?.required; else second">
                     First name is required
                    </ng-container>
                    <ng-template #second>
                      <ng-container *ngIf="!!preQualForm.get('FirstName').errors?.minlength; else third">
                        {{ SCData?.FirstNameInvalidError }}
                      </ng-container>
                      <ng-template #third>
                        <ng-container *ngIf="!!preQualForm.get('FirstName').errors?.pattern">
                           {{ SCData?.FirstNameInvalidError }}
                        </ng-container>
                      </ng-template>
                    </ng-template>
                  </span>
                </div>
              </div>
              <div   [class.disabled]="submitClicked || preQualForm.disabled" class="col-6 col-md-6 col-lg-6 col-xl-6 position-relative floating-label-wrapper mw-230 mar-left-8">
                <div class="floating-label-group " [class.floating-active]="getFloatingState('MI', miname)" [class.focused]="focusState['MI']">
                  <input id="mi_name" class="form-control w-100" formControlName="MI" maxlength="1" type="text"
                    autocomplete="mi_name" placeholder="ex: A"
                    [disabled]="preQualForm.disabled || preQualForm.invalid || submitClicked"
                    (focus)="preQualForm.get('MI').markAsUntouched(); miname.focus(); onFieldFocus('MI', true);"
                    (blur)="onFieldFocus('MI', false)" #miname [ngClass]="{
                    error:
                      (preQualForm.get('MI').touched ||
                        preQualForm.get('MI').dirty) &&
                      !preQualForm.get('MI').valid
                  }" />
                  <label for="mi_name">
                    <span class="default-label">MI <span class="span-otional" style="    font-family: 'Autonation Light' !important; font-size: 14px !important;">(optional)</span></span>
                    <span class="floating-label">Middle Initial</span>
                  </label>
                </div>
                <!-- <div class="valid-checkmark-icon valid-icon"
                  *ngIf="preQualForm.get('MI')?.valid && preQualForm.get('MI')?.value?.trim()"> </div>
                <div class="valid-checkmark-icon invalid-icon"
                  *ngIf="preQualForm.get('MI')?.invalid && preQualForm.get('MI')?.touched"></div> -->
                <div class="invalid-feedback error-width-for-half-row d-flex"
                  (click)="preQualForm.get('MI').markAsUntouched(); miname.focus()" *ngIf="
                !hasFocus(miname) &&
                preQualForm.get('MI').touched &&
                !preQualForm.get('MI').valid
              ">
                  <span class="form-validator_error" role="alert">
                    <ng-container *ngIf="preQualForm.get('MI')?.errors as errors">
                      <ng-container *ngIf="errors.maxlength; else checkPattern">
                        <span>{{ SCData?.MIInvalid }}</span>
                      </ng-container>
                      <ng-template #checkPattern>
                        <ng-container *ngIf="errors.pattern">
                          <span>{{ SCData?.MIInvalid }}</span>
                        </ng-container>
                      </ng-template>
                    </ng-container>
                  </span>
                </div>
              </div>
            </div>
            <!-- end of First name and Start of Last Name-->
            <div class="row mx-0 form-row w-100">
              <div   [class.disabled]="submitClicked || preQualForm.disabled" class="col-12 floating-label-wrapper">
                <div class="floating-label-group" [class.floating-active]="getFloatingState('LastName', lastname)" [class.focused]="focusState['LastName']">
                  <input id="lastNameId" class="form-control w-100 pr-5" maxlength="30" type="text"
                    (blur)="onFieldFocus('LastName', false);" autocomplete="family-name" formControlName="LastName"
                    placeholder="ex: Smith"
                    [disabled]="preQualForm.disabled || preQualForm.invalid || submitClicked"
                    (focus)="preQualForm.get('LastName').markAsUntouched(); lastname.focus();onFieldFocus('LastName', true);"
                    #lastname [ngClass]="{
                    'form-row-err':
                      !hasFocus(lastname) && (preQualForm.get('LastName').touched ||
                        preQualForm.get('LastName').dirty) &&
                      !preQualForm.get('LastName').valid 
                  }" />
                  <label for="lastNameId">
                    {{ SCData?.LastName }}

                  </label>
                </div>
                <!-- <div class="valid-checkmark-icon valid-icon" *ngIf="preQualForm.get('LastName')?.valid">

                </div>
                <div class="valid-checkmark-icon invalid-icon"
                  *ngIf="preQualForm.get('LastName')?.invalid && preQualForm.get('LastName')?.touched">

                </div> -->
                <div class="invalid-feedback error-width-for-full-row d-flex"
                  (click)="preQualForm.get('LastName').markAsUntouched(); lastname.focus()" *ngIf="
                    !hasFocus(lastname) &&
                    preQualForm.get('LastName').touched &&
                    !preQualForm.get('LastName').valid
                  ">
                  <span class="form-validator_error" role="alert">
                    <ng-container *ngIf="!!preQualForm.get('LastName').errors?.required; else second">
                     Last name is required
                    </ng-container>
                    <ng-template #second>
                      <ng-container *ngIf="!!preQualForm.get('LastName').errors?.minlength; else third">
                        {{ SCData?.LastNameInvalidError }}
                      </ng-container>
                      <ng-template #third>
                        <ng-container *ngIf="!!preQualForm.get('LastName').errors?.pattern">
                         {{ SCData?.LastNameInvalidError }}
                        </ng-container>
                      </ng-template>
                    </ng-template>
                  </span>
                </div>
              </div>
            </div>
            <!--end of last name and start of Email-->
            <div class="row mx-0 form-row w-100">
              <div   [class.disabled]="submitClicked || preQualForm.disabled" class="col-12 floating-label-wrapper">
                <div class="floating-label-group" [class.floating-active]="getFloatingState('Email', email)" [class.focused]="focusState['Email']">
                  <input id="email" class="form-control w-100 pr-2" type="text" maxlength="40" autocomplete="email"
                    placeholder=" " formControlName="Email" (blur)="onFieldFocus('Email', false); checkEmailDomain();"
                    [disabled]="preQualForm.disabled || preQualForm.invalid || submitClicked" [readOnly]="isLoggedIn && config?.Sitecore?.PreQualLeadInfo?.email"
                    (focus)="preQualForm.get('Email').markAsUntouched(); email.focus();onFieldFocus('Email', true);"
                    #email [ngClass]="{
                    'form-row-err':
                      !hasFocus(email) && (preQualForm.get('Email').touched ||
                        preQualForm.get('Email').dirty) &&
                      !preQualForm.get('Email').valid 
                  }" [attr.disabled]="disableEmailFieldFn"
                    [readonly]="isLoggedIn && config?.Sitecore?.PreQualLeadInfo?.email" />
                  <label for="email">
                    {{ SCData?.Email }}
                  </label>
                </div>
                <!-- <div class="valid-checkmark-icon valid-icon" *ngIf="preQualForm.get('Email')?.valid"></div>
                <div class="valid-checkmark-icon invalid-icon"
                  *ngIf="preQualForm.get('Email')?.invalid && preQualForm.get('Email')?.touched"> </div> -->
                <div class="invalid-feedback error-width-for-full-row d-flex"
                  (click)="preQualForm.get('Email').markAsUntouched(); email.focus()" *ngIf="
                    !hasFocus(email) &&
                    preQualForm.get('Email').touched &&
                    !preQualForm.get('Email').valid
                  ">
                  <span class="form-validator_error" role="alert">
                    <ng-container *ngIf="!!preQualForm.get('Email').errors?.required; else second">
                     Email is required
                    </ng-container>
                    <ng-template #second>
                      <ng-container *ngIf="!!preQualForm.get('Email').errors?.riskHigh; else emailInvalid">
                          {{ SCData?.LeadValidation_EmailInvalid || 'Please use valid email.'}}    
                      </ng-container>
                      <ng-template #emailInvalid>
                        <ng-container *ngIf="!preQualForm.get('Email').valid">
                         {{ SCData?.EmailInvalid }}
                        </ng-container>
                      </ng-template>
                    </ng-template>
                  </span>
                </div>
              </div>
            </div>
            <!-- Email suggestion badge -->
                <div role="alert" aria-live="polite" 
                  *ngIf="showEmailSuggestion && emailSuggestion && preQualForm.get('Email').valid"
                  class="email-suggestion-message">
                  <span class="email-suggestion-text">Did you mean:</span>
                  <button class="email-suggestion-badge" 
                    (click)="acceptEmailSuggestion()" 
                    (keyup.enter)="acceptEmailSuggestion()" 
                    [attr.aria-label]="'Update email domain to ' + emailSuggestion">
                    <span class="email-suggestion-address">{{ emailSuggestion }}</span>
                    <span class="email-suggestion-icon-wrapper">
                      <span class="email-suggestion-icon"></span>
                    </span>
                  </button>
                </div>
            <!--end of Email and start if phone -->
            <div class="row mx-0 form-row w-100">
              <div   [class.disabled]="submitClicked || preQualForm.disabled" class="col-12 floating-label-wrapper">
                <div class="floating-label-group" [class.floating-active]="getFloatingState('Phone', phone)" [class.focused]="focusState['Phone']">
                  <input id="phone" class="form-control w-100" formControlName="Phone" type="text" placeholder=" "
                    autocomplete="phone" [dtTextMask]="{ mask: phoneMask, guide: true }"
                    (blur)="onFieldFocus('Phone', false);"
                    [disabled]="preQualForm.disabled || preQualForm.invalid || submitClicked"
                    (focus)="preQualForm.get('Phone').markAsUntouched(); phone.focus();onFieldFocus('Phone', true)" #phone [ngClass]="{
                      'form-row-err':
                        !hasFocus(phone) && (preQualForm.get('Phone').touched ||
                          preQualForm.get('Phone').dirty) &&
                        (!!preQualForm.get('Phone').invalid || !!preQualForm.get('Phone').errors?.invalidAreaCode)
                    }" />
                  <label for="phone">
                    Phone Number
                  </label>
                </div>
                <!-- <div class="valid-checkmark-icon valid-icon" *ngIf="preQualForm.get('Phone')?.valid"> </div>
                <div class="valid-checkmark-icon invalid-icon"
                  *ngIf="preQualForm.get('Phone')?.invalid && preQualForm.get('Phone')?.touched"> </div> -->
                <div class="invalid-feedback error-width-for-half-row d-flex"
                  (click)="preQualForm.get('Phone').markAsUntouched(); phone.focus()" *ngIf="
                    !hasFocus(phone) &&
                    preQualForm.get('Phone').touched &&
                    (!!preQualForm.get('Phone').invalid || !!preQualForm.get('Phone').errors?.invalidAreaCode)
                  ">
                  <span class="form-validator_error" role="alert">
                    <ng-container *ngIf="!!preQualForm.get('Phone').errors?.required; else second">
                     {{ SCData?.PhoneRequiredError }}
                    </ng-container>
                    <ng-template #second>
                    <ng-container *ngIf="preQualForm.get('Phone').errors?.invalidAreaCode; else third">
                      {{ SCData?.PhoneInvalidAreaCode }}
                    </ng-container>
                  </ng-template>
                  <ng-template #third>
                    <ng-container *ngIf="!!preQualForm.get('Phone').errors?.riskHigh; else phoneInvalid">
                      {{ SCData?.LeadValidation_PhoneInvalid ||  'Please use valid phone number.' }} 
                    </ng-container>
                    <ng-template #phoneInvalid>
                      <ng-container *ngIf="!preQualForm.get('Phone').valid">
                       {{ SCData?.PhoneInvalid }}
                      </ng-container>
                    </ng-template>
                  </ng-template>
                  </span>
                </div>
              </div>
            </div>


            <!--Start of Address Field -->
            <div class="row mx-0 form-row w-100">
              <div   [class.disabled]="submitClicked || preQualForm.disabled" class="col-12 floating-label-wrapper" id="searchBoxContainer">
                <div class="floating-label-group"  [class.floating-active]="getFloatingState('Address', address)" [class.focused]="focusState['Address']">
                  <input id="Address" class="form-control w-100 pr-5" type="text" maxlength="50" placeholder=" "
                    autocomplete="address" formControlName="Address"
                    [disabled]="preQualForm.disabled || preQualForm.invalid || submitClicked"
                    (blur)="onFieldFocus('Address', false);"
                    (focus)="preQualForm.get('Address').markAsUntouched(); address.focus();onFieldFocus('Address', true)" #address [ngClass]="{
                     'form-row-err': !hasFocus(address) && !preQualForm.get('Address').valid && !preQualForm.get('Address').disabled && 
                            (preQualForm.get('Address').touched ||
                              preQualForm.get('Address').dirty ||
                              formSubmitAttempt)
                    }" />
                  <label for="Address">
                    Street Address
                  </label>
                </div>
                <!-- <div class="valid-checkmark-icon valid-icon" *ngIf="preQualForm.get('Address')?.valid"> </div>
                <div class="valid-checkmark-icon invalid-icon"
                  *ngIf="preQualForm.get('Address')?.invalid && preQualForm.get('Address')?.touched"> </div> -->
                <div class="invalid-feedback error-width-for-full-row d-flex"
                  (click)="preQualForm.get('Address').markAsUntouched(); address.focus()"
                  *ngIf="!hasFocus(address) && !preQualForm.get('Address').valid && preQualForm.get('Address').touched">
                  <span class="form-validator_error" role="alert">
                    <ng-container *ngIf="!!preQualForm.get('Address').errors?.required; else second">
                      Address is required
                    </ng-container>
                    <ng-template #second>
                      <ng-container *ngIf="!!preQualForm.get('Address').errors?.minlength; else third">
                        {{ SCData?.AddressInvalidError }}
                      </ng-container>
                      <ng-template #third>
                        <ng-container *ngIf="!!preQualForm.get('Address').errors?.pattern">
                         {{ SCData?.AddressInvalidError }}
                        </ng-container>
                      </ng-template>
                    </ng-template>
                  </span>
                </div>
              </div>

            </div>

            <div class="row mx-0 form-row w-100" *ngIf="showAddress2">
              <div   [class.disabled]="submitClicked || preQualForm.disabled" class="col-12 floating-label-wrapper">
                <div class="floating-label-group"  [class.floating-active]="getFloatingState('Address2', address2)" [class.focused]="focusState['Address2']">
                  <input id="Address2" class="form-control w-100 pr-5" type="text" maxlength="50" placeholder=" "
                    autocomplete="address" formControlName="Address2"
                    [disabled]="preQualForm.disabled || preQualForm.invalid || submitClicked"
                     (blur)="onFieldFocus('Address2', false);"
                    (focus)="preQualForm.get('Address2').markAsUntouched(); address2.focus(); onFieldFocus('Address2', true)" #address2 [ngClass]="{
                      error: !preQualForm.get('Address2').valid &&
                            (preQualForm.get('Address2').touched ||
                              preQualForm.get('Address2').dirty ||
                              formSubmitAttempt)
                    }" />
                  <label for="Address2">
                    Add Apt, Suite, or Other <span class="span-otional" style="font-family: 'Autonation Light' !important; font-size: 14px !important;">(optional)</span>
                  </label>
                </div>
                <!-- <div class="valid-checkmark-icon valid-icon"
                  *ngIf="preQualForm.get('Address2')?.valid && preQualForm.get('Address2')?.value?.trim()"> </div>
                <div class="valid-checkmark-icon invalid-icon"
                  *ngIf="preQualForm.get('Address2')?.invalid && preQualForm.get('Address2')?.touched"> </div> -->
                <div class="invalid-feedback error-width-for-full-row d-flex"
                  (click)="preQualForm.get('Address2').markAsUntouched(); address2.focus()"
                  *ngIf="!hasFocus(address2) && !preQualForm.get('Address2').valid && preQualForm.get('Address2').touched">
                  <span class="form-validator_error" role="alert">
                    <ng-container>
                      {{ SCData?.AddressInvalidError }}
                    </ng-container>
                  </span>
                </div>
              </div>
            </div>
            <div class="address-optional" [class.disabled]="submitClicked || preQualForm.disabled" (click)="!preQualForm.disabled && addAdditionalRow()" *ngIf="!showAddress2"> <span class="address-apt"> Add Apt, Suite, or
                Other </span><span style="font-family: 'Autonation Light' !important; font-size: 14px !important;" class="span-otional">(optional)</span> </div>



            <!-- End of Address Field Start of zipcode -->
            <div class="row mx-0 form-row w-100">
              <div   [class.disabled]="submitClicked || preQualForm.disabled" class="col-12 floating-label-wrapper">
                <div class="floating-label-group"  [class.floating-active]="getFloatingState('Zipcode', Zipcode)" [class.focused]="focusState['Zipcode']">
                  <input id="zip_code" class="form-control w-100 pr-5" autocomplete="postal-code" type="text"
                    placeholder=" " #Zipcode formControlName="Zipcode"
                    [disabled]="preQualForm.disabled || preQualForm.invalid || submitClicked"
                    [dtTextMask]="{ mask: zipCodeMask, guide: false }"
                     (blur)="onZipcodeBlur(); onFieldFocus('Zipcode', false);"
                    (focus)="preQualForm.get('Zipcode').markAsUntouched(); Zipcode.focus();onFieldFocus('Zipcode', true);" [ngClass]="{
                      'form-row-err': !hasFocus(Zipcode) && !preQualForm.get('Zipcode').valid && !preQualForm.get('Zipcode').disabled && 
                        (preQualForm.get('Zipcode').touched ||
                        preQualForm.get('Zipcode').dirty ||
                        formSubmitAttempt)
                    }" />
                  <label for="zip_code">
                    {{ SCData?.Zipcode }}
                  </label>
                </div>
                <!-- <div class="valid-checkmark-icon valid-icon" *ngIf="preQualForm.get('Zipcode')?.valid"> </div>
                <div class="valid-checkmark-icon invalid-icon"
                  *ngIf="preQualForm.get('Zipcode')?.invalid && preQualForm.get('Zipcode')?.touched"> </div> -->
                <div class="invalid-feedback error-width-for-half-row d-flex"
                  (click)="preQualForm.get('Zipcode').markAsUntouched(); Zipcode.focus()"
                  
                  *ngIf="!hasFocus(Zipcode) && preQualForm.get('Zipcode').touched && !preQualForm.get('Zipcode').valid">
                  <span class="form-validator_error" role="alert">
                    <ng-container *ngIf="!!preQualForm.get('Zipcode').errors?.required; else second">
                      Zip Code is required
                    </ng-container>
                    <ng-template #second>
                      <ng-container *ngIf="!preQualForm.get('Zipcode').valid">
                        {{ SCData?.ZipCodeInvalidError }}
                      </ng-container>
                    </ng-template>
                  </span>
                </div>
              </div>
            </div>
            <!-- End of zipcode Start of city Field and state-->
            <div class="row mx-0 form-row w-100 form-row-name">
              <!-- City -->
              <div   [class.disabled]="submitClicked || preQualForm.disabled" class="col-6 pr-3 floating-label-wrapper  mw-230 mar-rig-8" >
                <div class="floating-label-group " [class.floating-active]="getFloatingState('City', city)" [class.focused]="focusState['City']">
                  <input id="city" class="form-control w-100 pr-2" formControlName="City" type="text" maxlength="38"
                    autocomplete="home city" placeholder=" "
                    (blur)="onFieldFocus('City', false);"
                    [disabled]="preQualForm.disabled || preQualForm.invalid || submitClicked"
                    (focus)="preQualForm.get('City').markAsUntouched(); city.focus();onFieldFocus('City', true);" #city [ngClass]="{
                       'form-row-err': !hasFocus(city) && !preQualForm.get('City').valid && !preQualForm.get('City').disabled  && 
                            (preQualForm.get('City').touched ||
                              preQualForm.get('City').dirty ||
                              formSubmitAttempt)
                    }" />
                  <label for="city">
                    {{ SCData?.City }}
                  </label>
                </div>
                <!-- <div class="valid-checkmark-icon valid-icon" *ngIf="preQualForm.get('City')?.valid"> </div>
                <div class="valid-checkmark-icon invalid-icon"
                  *ngIf="preQualForm.get('City')?.invalid && preQualForm.get('City')?.touched"> </div> -->
                <div class="invalid-feedback error-width-for-half-row d-flex"
                  (click)="preQualForm.get('City').markAsUntouched(); city.focus()"
                  *ngIf="!hasFocus(city) && !preQualForm.get('City').valid && preQualForm.get('City').touched">
                  <span class="form-validator_error" role="alert">
                    <ng-container *ngIf="!!preQualForm.get('City').errors?.required; else second">
                      City is required
                    </ng-container>
                    <ng-template #second>
                      <ng-container *ngIf="!!preQualForm.get('City').errors?.pattern">
                        {{ SCData?.CityInvalidError }}
                      </ng-container>
                    </ng-template>
                  </span>
                </div>
              </div>

              <!-- State -->
              <div class="floating-label-wrapper col-6 mw-230 mar-left-8">
              <div   [class.disabled]="submitClicked || preQualForm.disabled" class="floating-label-group select-wrapper " [class.floating-active]="getFloatingState('State', State)" [class.focused]="focusState['State']">
                <label
                  for="state"
                  [class.floating]="!!preQualForm.get('State')?.value || hasFocus(state)"
                  (click)="openSelect(state)">
                  {{ SCData?.State || 'State' }}
                </label>

                <select
                  id="state"
                  class="form-control w-100 gradient ada-cursor"
                  formControlName="State"
                  #state
                  [disabled]="preQualForm.disabled || preQualForm.invalid || submitClicked"
                  (focus)="setFocus(state);onFieldFocus('state', true);"
                  (blur)="clearFocus(state);onFieldFocus('state', false);"
                  [ngClass]="{
                    error: !preQualForm.get('State').valid && !preQualForm.get('State').disabled  && 
                          (formSubmitAttempt || preQualForm.get('State').touched || preQualForm.get('State').dirty)
                  }">
                  <option value="" disabled hidden></option>
                  <option *ngFor="let state of states" [value]="state.Value">
                    {{ state?.Description }}
                  </option>
                </select>
              </div>
            </div>


            </div>
            <!-- End of city , state and start of birthdate and SSN-->
            <!-- end of birthdate and ssn , start of mortgage/rent -->
            <!-- *************************** mortgage/rent Start ***************************  -->
            <div class="row mx-0 form-row w-100 mortgage-income-row">
              <div   [class.disabled]="submitClicked || preQualForm.disabled" class="floating-label-wrapper col-12 position-relative">
                <div class="floating-label-group" [class.floating-active]="getFloatingState('MortgageRent', MortgageRent)" [class.focused]="focusState['MortgageRent']">
                  <input #MortgageRent type="text" id="MortgageRent" class="form-control w-100" usdOnly placeholder=" "
                    maxlength="7" formControlName="MortgageRent" MortgageRent
                    [disabled]="preQualForm.disabled || preQualForm.invalid || submitClicked"
                    (blur)="onFieldFocus('MortgageRent', false);"
                    (focus)="preQualForm.get('MortgageRent').markAsUntouched();onFieldFocus('MortgageRent', true);" [ngClass]="{
                    'form-row-err':
                     !hasFocus(MortgageRent) && (preQualForm.get('MortgageRent').touched ||
                        preQualForm.get('MortgageRent').dirty) &&
                      !preQualForm.get('MortgageRent').valid
                  }" />

                  <label for="MortgageRent" class="with-tooltip-label">
                    {{ SCData?.MortgageRent }}
                  </label>

                  <!-- Tooltip floats with label via absolute positioning -->
                  <an-tooltip class="floating-tooltip" [tooltipTitle]="SCData?.MortgageRent"
                    [tooltipContent]="SCData?.MortgageRentTooltip"
                    [tooltipMarginLeft]="isTabletView ? '-310px' : '-300px'" tooltipMarginBottom="3px"
                    [tooltipWith]="isTabletView ? '325px' : '328px'"
                    [tooltipArrowMarginLeft]="isTabletView ? '142px' : '132px'">
                    <a href="javascript:void(0)" class="tooltip-icon"></a>
                  </an-tooltip>
                </div>
                <!-- <div class="valid-checkmark-icon valid-icon" *ngIf="preQualForm.get('MortgageRent')?.valid"> </div>
                <div class="valid-checkmark-icon invalid-icon"
                  *ngIf="preQualForm.get('MortgageRent')?.invalid && preQualForm.get('MortgageRent')?.touched"> </div> -->

                <div class="invalid-feedback error-width-for-half-row d-flex"
                  (click)="preQualForm.get('MortgageRent').markAsUntouched(); MortgageRent.focus()" *ngIf="
                  !hasFocus(MortgageRent) &&
                  preQualForm.get('MortgageRent').touched &&
                  !preQualForm.get('MortgageRent').valid
                ">
                  <span class="form-validator_error" role="alert">
                    <ng-container *ngIf="!!preQualForm.get('MortgageRent').errors?.required; else invalidTemplate">
                     Monthly Mortage/Rent is required
                    </ng-container>
                    <ng-template #invalidTemplate>
                      {{ SCData?.MortgageRentInvalidError }}
                    </ng-template>
                  </span>
                </div>
              </div>
            </div>



            <div class="row mx-0 form-row w-100 mortgage-income-row">
              <div   [class.disabled]="submitClicked || preQualForm.disabled" class="floating-label-wrapper col-12 position-relative">
                <div class="floating-label-group" [class.floating-active]="getFloatingState('AnnualIncome', AnnualIncome)" [class.focused]="focusState['AnnualIncome']">
                  <input #AnnualIncome type="text" id="AnnualIncome" class="form-control w-100" usdOnly placeholder=" "
                    [disabled]="preQualForm.disabled || preQualForm.invalid || submitClicked"
                    maxlength="12" formControlName="AnnualIncome" AnnualIncome
                    (blur)="onFieldFocus('AnnualIncome', false);"
                    (focus)="preQualForm.get('AnnualIncome').markAsUntouched();onFieldFocus('AnnualIncome', true)" [ngClass]="{
                      'form-row-err':
                     !hasFocus(AnnualIncome) && 
                        (preQualForm.get('AnnualIncome').touched ||
                          preQualForm.get('AnnualIncome').dirty) &&
                        !preQualForm.get('AnnualIncome').valid
                    }" />

                  <label for="AnnualIncome" class="with-tooltip-label">
                    {{ SCData?.AnnualIncome }}
                  </label>

                  <!-- Tooltip positioned with label -->
                  <an-tooltip class="floating-tooltip" [tooltipTitle]="SCData?.AnnualIncome"
                    [tooltipContent]="SCData?.AnnualIncomeTooltip"
                    [tooltipMarginLeft]="isTabletView ? '-270px' : '-270px'" tooltipMarginBottom="3px"
                    [tooltipWith]="isTabletView ? '292px' : '292px'"
                    [tooltipArrowMarginLeft]="isTabletView ? '120px' : '120px'">
                    <a href="javascript:void(0)" class="tooltip-icon"></a>
                  </an-tooltip>
                </div>
                <!-- <div class="valid-checkmark-icon valid-icon" *ngIf="preQualForm.get('AnnualIncome')?.valid"> </div>
                <div class="valid-checkmark-icon invalid-icon"
                  *ngIf="preQualForm.get('AnnualIncome')?.invalid && preQualForm.get('AnnualIncome')?.touched"> </div> -->

                <div class="invalid-feedback error-width-for-half-row d-flex"
                  (click)="preQualForm.get('AnnualIncome').markAsUntouched();AnnualIncome.focus()"
                  *ngIf="!hasFocus(AnnualIncome) && preQualForm.get('AnnualIncome').touched && !preQualForm.get('AnnualIncome').valid">
                  <span class="form-validator_error" role="alert">
                    <ng-container *ngIf="!!preQualForm.get('AnnualIncome').errors?.required; else invalidTemplate">
                     Annual Income is required
                    </ng-container>
                    <ng-template #invalidTemplate>
                      {{ SCData?.AnnualIncomeInvalidError }}
                    </ng-template>
                  </span>
                </div>
              </div>
            </div>


            <div *ngIf="!config.Sitecore.isLegacyCreditApp" class="row mx-0 form-row w-100 ssn-container">

              <!-- DOB START -->
              <div   [class.disabled]="submitClicked || preQualForm.disabled" *ngIf="showBirthDate && IsDisplayDOBPrequal" class="floating-label-wrapper col-6 ssn-width">
                <div class="floating-label-group" [class.floating-active]="getFloatingState('DOB', DOB)" [class.focused]="focusState['DOB']">
                  <input type="text" id="dob" class="form-control w-100" formControlName="DOB" autocomplete="bday"
                  [disabled]="preQualForm.disabled || preQualForm.invalid || submitClicked"
                    [attr.placeholder]="hasDOBFocus ? 'MM/DD/YYYY' : ''" (blur)="onDOBFocus(false);onFieldFocus('DOB', false);"
                    (focus)="onDOBFocus(true); preQualForm.get('DOB').markAsUntouched();dateofbirth.focus();onFieldFocus('DOB', true);"
                    (change)="validateDOB()" #dateofbirth [dtTextMask]="{ mask: dobMask, guide: true }" [ngClass]="{
                      'form-row-err': !hasFocus(dateofbirth) && preQualForm.get('DOB').touched && !preQualForm.get('DOB').valid }" />
                  <label for="dob" [attr.aria-label]="SCData?.DateofBirth + ' (MM/DD/YYYY)'">
                    {{SCData?.DateofBirth}}
                  </label>
                </div>
                <!-- <div class="valid-checkmark-icon valid-icon"
                  *ngIf="preQualForm.get('DOB')?.valid && preQualForm.get('DOB')?.value?.trim()"> </div>
                <div class="valid-checkmark-icon invalid-icon" *ngIf="preQualForm.get('DOB')?.invalid"> </div> -->

                <div class="invalid-feedback error-width-for-half-row d-flex"
                  (click)="preQualForm.get('DOB').markAsUntouched();dateofbirth.focus()"
                  *ngIf="!hasFocus(dateofbirth) && preQualForm.get('DOB').touched && !preQualForm.get('DOB').valid">
                  <span class="form-validator_error" role="alert">
                    <ng-container *ngIf="!!preQualForm.get('DOB').errors?.required; else second">
                     Date of Birth is required
                    </ng-container>
                    <ng-template #second>
                      <ng-container>
                        {{ SCData?.DateOfBirthInvalidError }}
                      </ng-container>
                    </ng-template>
                  </span>
                </div>
              </div>
              <!-- DOB END -->

              <!-- OR Pipe Label -->
              <div class="col-1 orpipediv" *ngIf="isOrStandAlonePreQual && !config.Sitecore.isLegacyCreditApp">
                <div class="orpipelabel">{{ SCData?.IsORLabel }} </div>
              </div>

              <!-- SSN START -->
              <div   [class.disabled]="submitClicked || preQualForm.disabled" class="col-6 floating-label-wrapper ssn-width"
                *ngIf="showSSN && IsDisplaySSNPrequal && !config.Sitecore.isLegacyCreditApp">
                <div class="floating-label-group" [class.floating-active]="getFloatingState('SSN', SSN)" [class.focused]="focusState['SSN']">
                  <input id="ssn" class="form-control w-100" formControlName="SSN" #ssn autocomplete="SSN"
                  (blur)="onFieldFocus('SSN', false);"
                  [disabled]="preQualForm.disabled || preQualForm.invalid || submitClicked"
                  (focus)="onFieldFocus('SSN', true);"
                    autocomplete="off" placeholder=" " (focus)="checkSecureSSN(false)" (change)="validateSSN()"
                    [type]="ssnflag || !IE ? 'text' : 'password'" [dtTextMask]="{ mask: ssnMask, guide: ssnflag }"
                    [ngClass]="{
                      'form-row-err': !hasFocus(ssn) && preQualForm.get('SSN').touched && !preQualForm.get('SSN').valid,
                      'ssn-custom-mask': !ssnflag && !IE
                    }" />
                  <label for="ssn">{{ismob ? 'SSN' : 'Social Security Number'}} </label>
                </div>
                <!-- <div class="ssn-valid-checkmark-icon valid-icon"
                  *ngIf="preQualForm.get('SSN')?.valid && preQualForm.get('SSN')?.value?.trim()"> </div>
                <div class="ssn-valid-checkmark-icon invalid-icon" *ngIf="preQualForm.get('SSN')?.invalid"> </div> -->

                <!-- Eye Button -->
                <button tabindex="0" class="form-icon-eye dt-icon" [ngClass]="{
                    
                    'iconEyePositionStandAlone': IsStandAlonePreQual
                  }"
                  (click)="checkSecureSSN(true);toggleAriaPress($event);preQualForm.get('SSN').markAsUntouched();ssn.focus();"
                  (keyup)="$event?.keyCode === 13 ? checkSecureSSN(true) : null" aria-pressed="false"
                  aria-label="View SSN">
                   <span *ngIf="ssnflag" >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="none">
                      <path d="M7.74894 9.86478C6.5643 9.78952 5.41146 9.45023 4.37492 8.87177C3.04056 8.15157 1.82007 7.23803 0.752971 6.16077C0.375971 5.78877 0.228923 5.62976 0.228923 5.62976C0.0821692 5.46853 0.00182102 5.25778 0.0039474 5.03976C0.0038596 4.92441 0.0267438 4.81021 0.0712081 4.70377C0.115672 4.59733 0.180862 4.50078 0.262981 4.41977L0.391887 4.29578C1.17183 3.54054 1.99743 2.83389 2.86393 2.17978C3.05127 2.04645 3.24059 1.91609 3.43193 1.78876C3.9388 1.45076 4.46954 1.14998 5.01994 0.888763C5.35481 0.731354 5.69841 0.593129 6.04899 0.474762L6.06596 0.468781C6.68987 0.254231 7.34422 0.141442 8.00395 0.134766C8.66345 0.142193 9.31748 0.25564 9.94096 0.470764L10.0059 0.492767H10.0149L10.0729 0.512756H10.0779C10.3446 0.606756 10.6052 0.711418 10.8599 0.826752L10.9159 0.852753L10.93 0.859772L10.9699 0.878754L10.9849 0.885773C11.5353 1.14701 12.066 1.44779 12.5729 1.78577L12.6729 1.85178C12.8296 1.95644 12.9846 2.06377 13.138 2.17377C14.0499 2.86622 14.9182 3.6143 15.738 4.41376L15.753 4.42877C15.9084 4.58997 15.9958 4.80485 15.997 5.02878C15.9992 5.2471 15.9187 5.45816 15.7719 5.61975C15.7719 5.61975 15.625 5.77778 15.248 6.14978C14.4583 6.93849 13.59 7.64448 12.6569 8.25677C12.7499 8.34678 12.7569 8.35678 12.6569 8.25677C12.3236 8.47144 11.9803 8.67142 11.627 8.85675C10.5904 9.43521 9.43762 9.77451 8.25297 9.84976C8.16797 9.84976 8.08197 9.85477 7.99797 9.85577C7.91397 9.85677 7.83394 9.86778 7.74894 9.86478ZM8.01799 8.56476H8.15592H8.19389H8.19889L8.28398 8.55975H8.32597L8.41093 8.55176L8.49394 8.54178H8.50199L8.538 8.53677L8.5789 8.53076H8.585L8.61894 8.52478H8.62797L8.70597 8.51077H8.71598L8.74296 8.50476H8.757L8.79093 8.49777H8.80497L8.82695 8.49277H8.84391H8.86393L8.89494 8.48477H8.91093L8.9329 8.47876H8.94499L9.02299 8.45676H9.02995L9.05595 8.44876C9.34624 8.3598 9.62414 8.23448 9.88298 8.07578C10.3889 7.76711 10.809 7.33622 11.1049 6.82275C11.3862 6.33232 11.5374 5.7781 11.544 5.21277C11.544 5.19177 11.544 5.17276 11.544 5.15176V5.10675C11.544 5.08475 11.544 5.05975 11.544 5.05075V5.04276C11.544 5.01776 11.544 4.99176 11.544 4.96576V4.95676C11.5466 4.36075 11.3929 3.77447 11.0981 3.25647C10.8033 2.73847 10.3777 2.30687 9.86393 2.00476L9.76396 1.94577L9.73991 1.93277L9.71 1.91678C9.18637 1.6385 8.6029 1.49162 8.00993 1.48877H7.97099C7.43674 1.49249 6.90971 1.61297 6.42692 1.84177L6.39897 1.85577L6.37992 1.86478H6.37089C6.28422 1.90811 6.19996 1.95442 6.11796 2.00375C5.58924 2.32052 5.15325 2.77097 4.85392 3.30975C4.57679 3.81224 4.43454 4.37794 4.44096 4.95175V4.96075C4.44096 4.98575 4.44096 5.01178 4.44096 5.03778V5.04578C4.44096 5.05478 4.44096 5.07978 4.44096 5.10178V5.14676C4.44096 5.16776 4.44096 5.18676 4.44096 5.20776C4.44721 5.77314 4.59832 6.32748 4.87992 6.81778C5.17628 7.33183 5.5972 7.76306 6.10392 8.07178C6.33612 8.21398 6.58374 8.32938 6.84196 8.41577L6.92692 8.44278L6.95292 8.45078H6.96098L7.038 8.47278H7.05094L7.07194 8.47876H7.08891L7.11894 8.48676L7.13993 8.49176H7.1569L7.179 8.49677H7.19291L7.22795 8.50476H7.24101L7.26799 8.51077H7.27897L7.35697 8.52478H7.36601L7.39994 8.53076H7.40592L7.44596 8.53677L7.48197 8.54178H7.48893L7.57194 8.55176L7.658 8.55975H7.69999L7.78495 8.56476H7.78996H7.82792H7.99296H8.01799ZM6.59892 6.29675C6.51271 6.21232 6.43479 6.1199 6.36601 6.02075C6.27074 5.88462 6.19275 5.73716 6.13395 5.58176C6.04896 5.35575 6.00554 5.11622 6.0059 4.87476C6.00582 4.48053 6.12231 4.09508 6.34062 3.76682C6.55892 3.43855 6.86936 3.18212 7.23295 3.02975C7.47742 2.92726 7.73984 2.87457 8.00492 2.87476C8.27 2.87457 8.53243 2.92726 8.7769 3.02975C9.14049 3.18212 9.45105 3.43855 9.66935 3.76682C9.88766 4.09508 10.004 4.48053 10.0039 4.87476C10.0043 5.11622 9.96089 5.35575 9.8759 5.58176C9.81698 5.73761 9.73879 5.88544 9.64299 6.02176C9.57387 6.12094 9.49551 6.21335 9.40898 6.29776C9.03617 6.66633 8.53319 6.87328 8.00895 6.87378C7.48053 6.87459 6.97337 6.6656 6.59892 6.29276V6.29675Z" fill="var(--grayscale-300)"/>
                    </svg>
                  </span>
                   <span *ngIf="!ssnflag" >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="none">
                      <path d="M3.19019 9.75388L12.5362 0.733883L12.5442 0.726883C12.5838 0.687383 12.6151 0.640358 12.6362 0.588581C12.6573 0.536804 12.6679 0.481322 12.6672 0.425406C12.6665 0.369489 12.6547 0.31427 12.6324 0.263C12.6101 0.211731 12.5777 0.165449 12.5372 0.126883C12.4522 0.0460547 12.3395 0.000976562 12.2222 0.000976562C12.1049 0.000976562 11.9922 0.0460547 11.9072 0.126883L10.9802 1.02188C10.6393 0.861723 10.2894 0.721487 9.93219 0.601883C8.67999 0.154263 7.31139 0.154263 6.05919 0.601883C4.91243 1.00734 3.83357 1.58385 2.85919 2.31188C1.94722 3.00429 1.0789 3.75238 0.259193 4.55188C0.0993501 4.71068 0.00667549 4.92486 0.000346765 5.15009C-0.00598196 5.37532 0.0745202 5.59436 0.225194 5.76188C0.225194 5.76188 0.371193 5.92088 0.748193 6.29188C1.53837 7.08074 2.40685 7.78706 3.34019 8.39988L2.56519 9.14788C2.52405 9.1871 2.49129 9.23427 2.46891 9.28653C2.44653 9.33878 2.43499 9.39504 2.43499 9.45188C2.43499 9.50873 2.44653 9.56498 2.46891 9.61724C2.49129 9.66949 2.52405 9.71666 2.56519 9.75588C2.64884 9.83535 2.75945 9.88024 2.87482 9.88154C2.99019 9.88284 3.10178 9.84045 3.18719 9.76288L3.19019 9.75388ZM4.44019 5.13688V5.12888C4.44019 5.10288 4.44019 5.07688 4.44019 5.05188C4.44019 5.05188 4.44019 5.04588 4.44019 5.04288C4.44372 4.58266 4.53798 4.12765 4.71758 3.7039C4.89718 3.28015 5.1586 2.89598 5.48685 2.57339C5.81511 2.2508 6.20377 1.99612 6.63058 1.82392C7.05739 1.65172 7.51398 1.5654 7.97419 1.56988H8.01319C8.66728 1.57378 9.3083 1.75338 9.86919 2.08988L8.62819 3.28988C8.28052 3.17399 7.90781 3.15522 7.55025 3.23557C7.19269 3.31593 6.86385 3.49238 6.59919 3.74588C6.38088 3.95283 6.21633 4.2099 6.11979 4.4948C6.02326 4.7797 5.99765 5.08385 6.04519 5.38088C6.04519 5.38888 6.04519 5.39788 6.04519 5.40588C6.04519 5.41388 6.05119 5.44088 6.05519 5.45888C6.07185 5.54167 6.09424 5.6232 6.12219 5.70288L4.87319 6.90788C4.59099 6.41778 4.43948 5.86339 4.43319 5.29788C4.43319 5.27788 4.43319 5.25688 4.43319 5.23688V5.19188C4.44119 5.16988 4.44119 5.14588 4.44019 5.13688ZM7.40419 6.90288L9.87419 4.51788C9.87419 4.52688 9.88119 4.53588 9.88319 4.54588C9.89019 4.57088 9.89819 4.59488 9.90419 4.61988C10.0197 5.0511 9.97313 5.50973 9.77319 5.90888L9.76719 5.91988C9.75619 5.94188 9.74519 5.96288 9.73319 5.98388L9.70719 6.02788L9.68919 6.05788C9.51048 6.34397 9.26157 6.5796 8.96612 6.74237C8.67067 6.90515 8.33851 6.98966 8.00119 6.98788C7.79945 6.98867 7.59767 6.96004 7.40419 6.90288ZM15.7742 5.76088C15.7742 5.76088 15.6282 5.91988 15.2512 6.29088C14.1839 7.36793 12.9634 8.28145 11.6292 9.00188C10.5925 9.57978 9.43972 9.9187 8.25519 9.99388C8.17019 9.99388 8.08419 9.99988 8.00019 9.99988C7.91619 9.99988 7.83019 9.99988 7.74519 9.99388C6.77474 9.93895 5.82401 9.6972 4.94519 9.28188L6.10719 8.15988C6.67715 8.50964 7.33349 8.6932 8.00219 8.68988C8.92124 8.7032 9.80875 8.35509 10.4737 7.72048C11.1386 7.08588 11.5277 6.21555 11.5572 5.29688C11.5572 5.27688 11.5572 5.25588 11.5572 5.23588V5.19088C11.5572 5.16888 11.5572 5.14388 11.5572 5.13488V5.12688C11.5572 5.10088 11.5572 5.07488 11.5572 5.04988C11.5572 5.04988 11.5572 5.04388 11.5572 5.04088C11.5637 4.44173 11.4083 3.85194 11.1072 3.33388L12.5742 1.91788C12.7655 2.04388 12.9549 2.17422 13.1422 2.30888C14.0542 3.00129 14.9225 3.74938 15.7422 4.54888C15.9023 4.70804 15.995 4.92277 16.001 5.14847C16.0069 5.37417 15.9257 5.5935 15.7742 5.76088Z" fill="var(--grayscale-300)"/>
                    </svg>
                  </span>
                </button>

                <div class="invalid-feedback error-width-for-half-row d-flex"
                  (click)="preQualForm.get('SSN').markAsUntouched();ssn.focus()"
                  *ngIf="!hasFocus(ssn) && preQualForm.get('SSN').touched && !preQualForm.get('SSN').valid">
                  <span class="form-validator_error" role="alert">
                    <ng-container *ngIf="!!preQualForm.get('SSN').errors?.required; else second">
                      {{ismob ? 'SSN is required' : 'Social Security Number is required'}}
                    </ng-container>
                    <ng-template #second>
                      <ng-container *ngIf="!!preQualForm.get('SSN').errors?.pattern; else invalidTemplate">
                         {{ismob ? 'SSN is invalid' : 'Social Security Number is invalid'}} 
                      </ng-container>
                      <ng-template #invalidTemplate>
                        {{ismob ? 'SSN is invalid' : 'Social Security Number is invalid'}} 
                      </ng-template>
                    </ng-template>
                  </span>
                </div>
              </div>
              <!-- SSN END -->
            </div>


          </div>
        </div>
      </form>

      <div class="prequal-t3-button">
          <button id="getPrequal" type="button" [disabled]="preQualForm.invalid || submitClicked"
            class="prequal-t3-btn" (click)="submitPreQualApplication()">
            {{ apiDomain ? "Get Prequalified" : SCData?.NextCta}}
          </button>
      </div>

      <!-- ***************************Start of disclaimer ***************************  -->
      <div class="row mx-0 form-row disclaimer-row  an-p-line-height" [ngClass]="{'prequal-t3-disclaimer-form' : apiDomain}"
        *ngIf="IsStandAlonePreQual ? IsStandAlonePreQual : (preQualiFyMe)"
        [innerHTML]="sanitizedDisclaimer">
      </div>

    </div>
    <dt-prequal-modal-result class="" *ngIf="showConfirmation"  [ngClass]="{'showConfirmation-isVinAvailable' : isVinAvailable}" [outcome]="outcome" [isVinAvailable]="isVinAvailable"
      (back)=backClicked($event)></dt-prequal-modal-result>
  </div>

</div>


<div class="dt-modal" tabindex="-1" role="dialog" *ngIf="showJackedModal" (click)="closeJacked()">
  <div class="dt-modal-dialog pqrj" role="document">
    <div class="dt-modal-content">
      <div class="close-modal " data-dismiss="modal">
        <div class="close-x" (click)="closeJacked()">
          <img type="image/svg+xml" alt="close"
            src="data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20viewBox%3D%220%200%2017%2017%22%3Ea%20%20%3Cdefs%3E%20%3Cstyle%3E.clsa%2C.clsc%7Bfill%3A%230A3453%3B%7D.clsa%7Bclip-rule%3Aevenodd%3B%7D.clsb%7Bclip-path%3Aurl%28%23clsa%29%3B%7D.clsd%7Bclip-path%3Aurl%28%23clsb%29%3B%7D%20%3C%2Fstyle%3E%20%3CclipPath%20id%3D%22clsa%22%3E%3Cpath%20class%3D%22clsa%22%20d%3D%22M1.495-16.278%2C17.722-.051l-.773.773L.722-15.505Z%22%20transform%3D%22translate%28-0.722%2016.278%29%22%20%2F%3E%20%3C%2FclipPath%3E%20%3CclipPath%20id%3D%22clsb%22%3E%3Cpath%20class%3D%22clsa%22%20d%3D%22M16.949-16.278l.773.773L1.495.722.722-.051Z%22%20transform%3D%22translate%28-0.722%2016.278%29%22%20%2F%3E%20%3C%2FclipPath%3E%20%20%3C%2Fdefs%3E%20%20%3Cg%20transform%3D%22translate%28-0.722%2016.278%29%22%3E%20%3Cg%20class%3D%22clsb%22%20transform%3D%22translate%280.722%20-16.278%29%22%3E%3Cpath%20class%3D%22clsc%22%20d%3D%22M2.151-23.349%2C26.105.605l-8.5%2C8.5L-6.349-14.849Z%22%20transform%3D%22translate%28-1.378%2015.622%29%22%20%2F%3E%20%3C%2Fg%3E%20%3Cg%20class%3D%22clsd%22%20transform%3D%22translate%280.722%20-16.278%29%22%3E%3Cpath%20class%3D%22clsc%22%20d%3D%22M17.605-23.349l8.5%2C8.5L2.151%2C9.105l-8.5-8.5Z%22%20transform%3D%22translate%28-1.378%2015.622%29%22%20%2F%3E%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%20%3C%2Fsvg%3E">
        </div>
      </div>
      <div class="modal-body">
        <div class="jacked-body row">
          <span class="jacked-image" [innerHTML]="creditAppConfigData?.JackedImage | ANSafeHtml"></span>
          <span class="jacked-title">{{ creditAppConfigData?.JackedTitle }}</span>
          <span class="jacked-subtitle">{{ creditAppConfigData?.JackedMessage }} </span>
          <span class="jacked-buttons">
            <button class="secondary-cta ml-auto" (click)="closeJacked()">{{ creditAppConfigData?.JackedCTA }}</button>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>